import { render, staticRenderFns } from "./DrawSVGIcon.vue?vue&type=template&id=67b41def&scoped=true&"
import script from "./DrawSVGIcon.vue?vue&type=script&lang=js&"
export * from "./DrawSVGIcon.vue?vue&type=script&lang=js&"
import style0 from "./DrawSVGIcon.vue?vue&type=style&index=0&id=67b41def&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b41def",
  null
  
)

export default component.exports